var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bar-chart',{attrs:{"xdata":_vm.xdata,"series":_vm.series,"rotate":0,"type":_vm.status,"barcolor":_vm.barcolor,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }